export const COLOR = "#004070";
